import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap';

export default class ListCollapse extends Component {
  static propTypes = {
    children: PropTypes.node,
    reveal: PropTypes.bool,
    onClick: PropTypes.func,
  }

  static defaultProps = {
    children: null,
    reveal: false,
    onClick: null,
  }

  constructor(props) {
    super(props);
    this.state = {
      reveal: props.reveal,
    }
  }

  handleClick = (e) => {
    e.preventDefault();
    this.setState({
      reveal: !this.state.reveal,
    });

    if(this.props.onClick) {
      this.props.onClick(e);
    }
  }

  render() {
    return (
      <Row
        className={`ListCollapse expandableRow ${this.props.reveal ? 'showRow' : null}`}
        onClick={this.handleClick}
      >
        <Col xs={12} className="expandableRowContent">
          <Row>
            {this.props.children}
          </Row>
        </Col>
      </Row>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ListCollapse.jsx